import { render, staticRenderFns } from "./Page6.vue?vue&type=template&id=1a1a9950&scoped=true"
import script from "./Page6.vue?vue&type=script&lang=js"
export * from "./Page6.vue?vue&type=script&lang=js"
import style0 from "./Page6.vue?vue&type=style&index=0&id=1a1a9950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1a9950",
  null
  
)

export default component.exports